import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../store/Reducers/NotificationSnackbarSlice';
import { NavigationService } from '../../api/services/navigationService';
import { setNavigationPages } from '../../store/Reducers/NavigationSlice';
import { NavigationDatagrid } from '../../components/DataGrid/NavigationDatagrid/NavigationDatagrid';

export const NavigationPage = () => {
  const dispatch = useDispatch();

  const retrieveNavigationPages = async () => {
    try {
      const res = await NavigationService.getAllNavigations();
      dispatch(setNavigationPages(res));
    } catch (e: any) {
      dispatch(
        showNotification({
          message: `Failed to retrieve navigation pages. ${e?.response?.data || ''}`,
        }),
      );
    }
  };

  useEffect(() => {
    retrieveNavigationPages();
  }, []);

  return (
    <>
      <NavigationDatagrid reload={retrieveNavigationPages} />
    </>
  );
};
